import { useState } from 'react';
import { SearchDateRangeForm } from 'src/components/common/form/search/SearchDateRangeForm';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { SearchSectionDoubleForm } from 'src/components/common/form/search/SearchSectionDoubleForm';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import useUiuxStore from 'src/store/useUiuxStore';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { getUserBySearch } from 'src/apis/authApi';
import { getThirdMenuModalList } from 'src/apis/menuApi';

import { defaultSYS5020_R01Filter, useSYS5020_R01Store } from './Store_SYS5020_R01';
import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

interface Props {
    onEnterKeyDown: () => void;
}

export const SearchSection_SYS5020_R01 = ({ onEnterKeyDown }: Props) => {
    const { SYS5020_R01Filter, setSYS5020_R01Filter } = useSYS5020_R01Store();
    const { setCodeSearchModalProps } = useUiuxStore();
    const { actionTypeList } = useCommonCodeStore();

    const [pickerVisible, setPickerVisible] = useState(false);
    const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({
        top: 0,
        left: 0,
    });

    const userFocusId = 'user_search_SYS5020';
    const menuFocusId = 'menu_search_SYS5020';

    const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
        {
            fieldName: 'userId',
            category: '사용자',
            focusId: userFocusId,
            responseMapping: {
                userId: 'userId',
                userNm: 'userNm',
            },
            searchFunction: async (code: string) => {
                const res = await getUserBySearch('');
                return res.data.data.find((v: any) => v.userId === code);
            },
            extraFilter: () => ({
                userId: SYS5020_R01Filter.userId || '',
                userNm: SYS5020_R01Filter.userNm || '',
            }),
        },
        {
            fieldName: 'programId',
            category: '프로그램',
            focusId: menuFocusId,
            responseMapping: {
                menuCd: 'programId',
                menuNm: 'programNm',
            },
            searchFunction: async (code: string) => {
                const res = await getThirdMenuModalList('');
                return res.data.data.find((v: any) => v.menuCd === code);
            },
            extraFilter: () => ({
                programId: SYS5020_R01Filter.programId || '',
                programNm: SYS5020_R01Filter.programNm || '',
            }),
        },
    ];

    const { getFieldHandlers } = useInfoFormEvents({
        editData: SYS5020_R01Filter,
        setEditData: setSYS5020_R01Filter,
        defaultData: defaultSYS5020_R01Filter,
        infoFieldConfigs,
        setCodeSearchModalProps,
        formName: 'SYS5020_R01_search',
    });

    return (
        <SearchSectionDoubleForm>
            <SearchDateRangeForm
                label="기간"
                visible={pickerVisible}
                setVisible={setPickerVisible}
                dateRange={SYS5020_R01Filter.dateRange}
                setDateRange={(dateRange) => setSYS5020_R01Filter({ dateRange })}
                pickerPosition={pickerPosition}
                setPickerPosition={setPickerPosition}
            />

        <SearchDropDownForm<SysCodeDto>
                label="사용구분"
                value={SYS5020_R01Filter.actionType}
                optionList={actionTypeList}
                onChangeValue={(value) =>
                    setSYS5020_R01Filter({ actionType: value === 'all' ? '' : value })
                }
            />

            <SearchCodeModalForm
                label="Login ID"
                value={SYS5020_R01Filter.userId}
                valueLabel={SYS5020_R01Filter.userNm}
                handleFoucsId={userFocusId}
                onChange={getFieldHandlers('userId').onChange}
                onDoubleClick={getFieldHandlers('userId').onDoubleClick}
                onKeyDown={getFieldHandlers('userId').onEnterKeyDown}
            />

            <SearchCodeModalForm
                label="프로그램 ID"
                value={SYS5020_R01Filter.programId}
                valueLabel={SYS5020_R01Filter.programNm}
                handleFoucsId={menuFocusId}
                onChange={getFieldHandlers('programId').onChange}
                onDoubleClick={getFieldHandlers('programId').onDoubleClick}
                onKeyDown={getFieldHandlers('programId').onEnterKeyDown}
            />

            

            <div />
        </SearchSectionDoubleForm>
    );
};

export default SearchSection_SYS5020_R01;
